var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLinkUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.6,12.5c-0.9,0-1.6,0.7-1.6,1.6V22c0,0.6-0.5,1.1-1.1,1.1H4.7c-0.6,0-1.1-0.5-1.1-1.1V6.7 c0-0.6,0.5-1.1,1.1-1.1H15c0.9,0,1.6-0.7,1.6-1.6S15.9,2.5,15,2.5H4.7c-2.3,0-4.2,1.9-4.2,4.2v15.2c0,2.3,1.9,4.2,4.2,4.2H20 c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V14C24.2,13.2,23.5,12.5,22.6,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.7,8.6c0-0.4-0.2-0.8-0.5-1.1l-5.4-4.7c-0.3-0.3-0.7-0.4-1.1-0.4s-0.8,0.2-1.1,0.5 c-0.3,0.3-0.4,0.7-0.4,1.1s0.2,0.8,0.5,1.1l2.4,2.1h-1.6C14,7.2,8.8,12.5,8.8,18.9v1.3c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6v-1.3 c0-4.7,3.8-8.6,8.6-8.6H26c0.3,0,0.6-0.1,0.9-0.3c0.2-0.1,0.3-0.2,0.5-0.4S27.8,9,27.7,8.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLinkUnion);
export default __webpack_public_path__ + "static/media/nav_link_union.f7066b30b7ebb499ec4dd3684b882b7d.svg";
export { ForwardRef as ReactComponent };